import styles from "./TeamDetails.module.css";

const teamDetailsStyle = {
    outerContainer: `hidden screen-500:flex items-end justify-between min-h-[57px] w-full ${styles.outerContainer}`,
    back_btn: `flex items-center gap-1 px-[12px] py-[3px] border-none text-[14px] ${styles.back_btn}`,
    team_details_wrpr: `flex items-center gap-2 ${styles.team_details_wrpr}`,
    teamDetailsContainer:`flex items-center gap-2`,
    imageContainer: `max-w-[60px] max-h-[60px]`,
    image: `w-full h-full max-w-[30px] ${styles.image}`,
    teamName: `text-[17px] font-[400] text-center capitalize ${styles.teamName}`,
    versusText: `text-[18px] font-[400] ${styles.versusText}`,
    genderBanner: `flex gap-2 items-center rounded-full px-3 py-[2px] border border-red-500 bg-white`,
    genderText: `text-[10px] font-[500] text-red-500 md:text-[12px] uppercase`
}

export { teamDetailsStyle}